// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"eb0f0533","191":"d91d2cd8","479":"be0272f4","826":"a285ca28","874":"7e0b0ff7"}[chunkId] + ".chunk.js";
};